import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from "react-router-dom"

export const NotFoundPage = () => {
  return (
    <Container>
      <Row>
        <Col>페이지를 찾을 수 없습니다.</Col>
      </Row>
      <Row>
        <Link to="/">홈으로 가기</Link>
      </Row>
    </Container>
  )
}
